import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

//const API_ROOT = 'http://localhost/api'

export const getQualityCheckList = (masterProjectCode, projectCode, pageSize, pageNumber) => {
  const url = `${API_ROOT}/subproject/quality-check-list/page?masterProjectCode=${masterProjectCode || ''}&projectCode=${projectCode || ''}&pageSize=${pageSize || 0}&pageNumber=${pageNumber || 0}`
  return doGet(url)
}

export const saveQualityCheckList = (request) => {
  const url = `${API_ROOT}/subproject/quality-check-list/save`
  return doPost(url, request)
}

export const getQualityCheckListHist = (projectCode, pageSize, pageNumber) => {
  const url = `${API_ROOT}/subproject/quality-check-list/history?projectCode=${projectCode || ''}&pageSize=${pageSize || 0}&pageNumber=${pageNumber || 0}`
  return doGet(url)
}

